import { useState, useEffect } from 'react';
import { finance } from '../utils/data';
import { tableHeader, tableData, title } from '../utils/style';
import axios from 'axios';
import { url } from '../utils/config';
import Table from '../reusable_components/Table';
import formatNumberToUs from '../custom_functions/formatNumberToUs';


function OperatingCost() {


    const options = [
        {
            header: 'Scheduled Resource',
            key: 'resource'
        },
        {
            header: 'Scheduled for Duration',
            key: 'duration'
        },
        {
            header: 'Resource Cost/hr',
            key: 'cost',
            render: (data) => {
                return `$${formatNumberToUs(data.cost?.toFixed(2))}`
            }
        },
        {
            header: 'Work Order Value',
            render: (data) => {
                return `$${formatNumberToUs(data.workOrder?.toFixed(2))}`
            }
        },
    ]

    const excludeFilter = []

    return(
        <div className="p-4">
            <div className={`${title} mb-4`}>Operating Cost</div>
            
            <Table 
                url={url + '/operating_cost'} 
                options={ options } 
                pagination 
                noButton
                noFilter
            />
        </div>
    )
}

export default OperatingCost;